import * as styledComponents from 'styled-components';

// import { ThemeInterface } from './';

const { default: styled, css, createGlobalStyle, keyframes, ThemeProvider } = styledComponents;

export { styled, css, createGlobalStyle, keyframes, ThemeProvider };
